export default "__VITE_ASSET__15e36c38__"